import * as React from 'react';
import * as Dictionary from 'Models/Dictionary';
import {WrappedFieldProps} from 'redux-form';
import {OptionsElement} from './../../../../Models/ViewManagementModel';

type Props = {
    label: string;
    type: string;
    max?: number;
    min?: number;
    disabled: boolean;
    options: Array<OptionsElement>;
    e2eId?: string
};

// export default class CarCategorySelect extends React.Component<CarCategorySelectP, {}> {
class CarCategorySelect extends React.PureComponent<WrappedFieldProps & Props> {
    public handleClick(value) {
        if (this.props.disabled) {
            return null;
        } else {
            this.props.input.onChange(value);
        }
    }

    public render() {
        const {input, meta, label, options, disabled} = this.props;
        return (
            <div className="form-field">
                <label htmlFor={input.name} className="form-field__label">{label}</label>
                <div className="form-field__group form-field__group--border">
                    {options.map((element, idx) => {
                        const active = element.value === input.value;
                        return (
                            <div key={`${element}-${idx}`}
                                 date-e2eid={(this.props.e2eId) ? this.props.e2eId + "-" + idx : null}
                                 className={`form-field__group-single ${active ? 'form-field__group-single--active' : ''}`}
                                 onClick={() => this.handleClick(element.value)}>
                                <img src={Dictionary.TurnedOffCarCategoryImage.get(element.value)} alt=""
                                     className="form-field__group-single-img"/>
                            </div>
                        );
                    })}
                </div>
                <div className="form-field__group">
                    {options.map((element, idx) => {
                        return (
                            <p key={`${element}_title-${idx}`} className={`form-field__group-single form-field__group-single--small`}>
                                {element.label}
                            </p>
                        );
                    })}
                </div>
                {(meta.touched &&
                    (meta.error && (
                        <div className="form-field__error">{meta.error}</div>
                    ))) ||
                (meta.warning && <span>{meta.warning}</span>)}
            </div>
        );
    }
}

export default CarCategorySelect;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/CarCategorySelect.tsx